// extracted by mini-css-extract-plugin
export default {"userIcon":"AssignDepositButton_userIcon__UGqbS"};